module.exports = __webpack_public_path__ + "img/task_detail_setting.6df2d91.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/setting-wizard/task_detail_setting.svg
// module id = 1ubB
// module chunks = 1